// uses ./appsListItem.less
/* eslint-disable react/jsx-no-useless-fragment */
import PropTypes from 'prop-types';

import React from 'react';
import AppActions from '../../common/appActions/AppActions';
import APPACTIONS_DISPLAY_VARIANT from '../../../enums/APPACTIONS_DISPLAY_VARIANT';
import getTextForAppDisableReason from '../../common/getTextForAppDisableReason';
import customBadgeImage from '../custom-badge.png';
import newBadgeImage from '../new-badge.png';
import connectIcon from '../connect-icon.png';
import protectIcon from '../protect-icon.png';

function getPlatformIcons(platform, className) {
    return (
        <>
            {platform ? (
                {
                    connect: <img src={connectIcon} className={className} />,
                    protect: <img src={protectIcon} className={className} />,
                    both: (
                        <>
                            <img src={connectIcon} className={className} />
                            &nbsp;
                            <img src={protectIcon} className={className} />
                        </>
                    ),
                }[platform]
            ) : (
                <img src={connectIcon} className={className} />
            )}
        </>
    );
}

function badge(sideloaded, isNew) {
    if (sideloaded) {
        return <img className="appsListItem-customBadge" src={customBadgeImage} />;
    }
    if (!sideloaded && isNew) {
        return <img className="appsListItem-newBadge" src={newBadgeImage} />;
    }
}

class AppsListItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isDropdownOpen: false,
        };
    }

    onDropdownClick() {
        this.setState((prevState) => ({ isDropdownOpen: !prevState.isDropdownOpen }));
    }

    onBlur() {
        this.setState({ isDropdownOpen: false });
    }

    render() {
        const dropdownData = {
            isOpen: this.state.isDropdownOpen,
            onClick: this.onDropdownClick.bind(this),
        };

        return (
            <div
                data-id={this.props.appId}
                className={`appsListItem${
                    this.props.isDisabled && this.props.userExists ? ' appsListItem--disabled' : ''
                }`}
                onClick={() => this.props.history.push(`/apps/${this.props.appId}`)}
                onMouseLeave={() => this.onBlur()}
            >
                {badge(this.props.sideloaded, this.props.isNew)}
                <div className="appsListItem-overflowWrapper">
                    <div className="appsListItem-logo-wrapper">
                        <img className="appsListItem-logo" src={this.props.appLogo} />
                        {this.props.isDisabled && this.props.userExists && (
                            <div className="appsListItem__disabled-text">
                                {getTextForAppDisableReason(this.props.disableReason, this.props.actsAsAdmin)}
                            </div>
                        )}
                    </div>
                    <div className="appsListItem-info">
                        <div className="appsListItem-info-head">
                            <div>
                                <h3 className="appsListItem-info-title">
                                    {this.props.name}&nbsp;
                                    {getPlatformIcons(this.props.platform, 'appsListItem-info-platformIcon')}
                                </h3>
                                <AppActions
                                    variant={APPACTIONS_DISPLAY_VARIANT.APPS_LIST_ITEM}
                                    className="appsListItem-info-actions"
                                    dropdownData={dropdownData}
                                    {...this.props}
                                />
                            </div>
                        </div>
                        <p className="appsListItem-info-description">
                            {this.props.description}&nbsp;
                            <span
                                title={`More info about ${this.props.name || 'application'}`}
                                className="appsListItem-info-more"
                            >
                                More
                            </span>
                        </p>
                    </div>
                </div>
            </div>
        );
    }
}

AppsListItem.propTypes = {
    history: PropTypes.object.isRequired,
    appId: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    platform: PropTypes.string,
    sideloaded: PropTypes.bool,
    isNew: PropTypes.bool.isRequired,
    appLogo: PropTypes.string.isRequired,
    isAvailable: PropTypes.bool,
    description: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    status: PropTypes.string,
    isDisabled: PropTypes.bool,
    disableReason: PropTypes.arrayOf(PropTypes.string),
    actsAsAdmin: PropTypes.bool.isRequired,
    userExists: PropTypes.bool,
};

export default AppsListItem;
